import { useTasksContagem } from '../hooks/useTasks';
import { cn } from '@/lib/utils';

// Mostra um badge compacto ao lado do label "Minhas tarefas" indicando contagem
// de tasks atrasadas (vermelho) ou pra hoje (âmbar). Atualiza a cada 60s.
//
// Lógica de tom:
//  - atrasadas > 0     → vermelho com count
//  - hoje > 0          → âmbar com count
//  - próximos_7 > 0    → neutro com count (só se hoje + atrasadas == 0)
//  - 0 ativas          → sem badge
export function TabBadgeTarefas() {
  const { data } = useTasksContagem();
  if (!data) return null;
  const { atrasadas, hoje, proximos_7_dias } = data;

  if (atrasadas > 0) {
    return (
      <span
        className={cn(
          'ml-1.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full',
          'text-[0.65rem] font-bold leading-none',
          'bg-[var(--danger)] text-white',
        )}
        title={`${atrasadas} tarefa(s) atrasada(s)`}
      >
        {atrasadas}
      </span>
    );
  }
  if (hoje > 0) {
    return (
      <span
        className={cn(
          'ml-1.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full',
          'text-[0.65rem] font-bold leading-none',
          'bg-[#facc15] text-[#7c2d12]',
        )}
        title={`${hoje} tarefa(s) para hoje`}
      >
        {hoje}
      </span>
    );
  }
  if (proximos_7_dias > 0) {
    return (
      <span
        className={cn(
          'ml-1.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full',
          'text-[0.65rem] font-semibold leading-none',
          'bg-surface2 text-text-2',
        )}
        title={`${proximos_7_dias} tarefa(s) nos próximos 7 dias`}
      >
        {proximos_7_dias}
      </span>
    );
  }
  return null;
}
